import { BridgeComponent } from "@hotwired/strada"

export default class extends BridgeComponent {
  static component = "overflow-menu"
  static targets = ["trigger"]

  connect() {
    super.connect()
    this.notified = false
    this.onBridgeReady = () => this.notifyBridgeOfConnect()
    this.onRegisterOverflow = () => {
      this.notified = false
      this.notifyBridgeOfConnect()
    }

    document.addEventListener("web-bridge:ready", this.onBridgeReady)
    document.addEventListener("depozen:register-native-overflow", this.onRegisterOverflow)

    this.bridgeComponentsObserver = new MutationObserver(() => {
      this.notifyBridgeOfConnect()
    })
    this.bridgeComponentsObserver.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ["data-bridge-components"]
    })

    this.notifyBridgeOfConnect()
  }

  disconnect() {
    document.removeEventListener("web-bridge:ready", this.onBridgeReady)
    document.removeEventListener("depozen:register-native-overflow", this.onRegisterOverflow)
    this.bridgeComponentsObserver?.disconnect()
    super.disconnect()
  }

  triggerTargetConnected() {
    this.notifyBridgeOfConnect()
  }

  notifyBridgeOfConnect() {
    if (this.notified || !this.enabled || !this.hasTriggerTarget) return

    this.notified = true

    this.send("connect", { label: "" }, () => {
      this.openActionsMenu()
    })
  }

  openActionsMenu() {
    if (this.hasTriggerTarget) {
      this.triggerTarget.click()
      return
    }

    window.__depozenOpenActionsMenu?.()
  }
}
